import styled from 'styled-components'
import { getBridgeBuilderTypografy } from '@features/nbee/SimpleBridgeBuilderForm/styled'

export const Divider = styled.hr`
  border: none;
  border-top: 1px solid #dfe4e8;
  margin: 1rem 0;
`

export const SettingsTitle = styled.h2`
  && {
    font-size: 0.875rem;
    font-weight: 600;
    text-align: left;
    margin: 0 0 0.75rem;
    color: #191919;
  }
`

export const ModalAddOptionCard = styled.div`
  ${getBridgeBuilderTypografy};

  padding: 1rem 2rem;

  & > div {
    margin-bottom: 1rem;
  }
`

export const ModalAddOptionErrorMessage = styled.div`
  font-size: 0.8rem;
  line-height: 1.1rem;
  a {
    word-break: break-all;
  }
`
